var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImageDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283712",
    "data-name": "Pfad 283712",
    d: "M35.938,25.063a4.028,4.028,0,0,0-3.776-3.114.919.919,0,0,1,0-.128,6.069,6.069,0,0,0-1.964-5.04,5.861,5.861,0,0,0-4.951-1.243,5.924,5.924,0,0,0-3.993,3.095.983.983,0,0,0-.1-.03,5.269,5.269,0,0,0-5.414,1.43,6.769,6.769,0,0,0-1.563,6.823A5.779,5.779,0,0,0,20,31.075h1a.575.575,0,0,0,0-1.15H20a4.645,4.645,0,0,1-4.738-3.43,5.607,5.607,0,0,1,1.291-5.655A4.119,4.119,0,0,1,20.82,19.7a2.424,2.424,0,0,1,.244.084.842.842,0,0,0,1.135-.475,4.658,4.658,0,0,1,7.248-1.659,4.83,4.83,0,0,1,1.564,4.113,1.063,1.063,0,0,0,.912,1.269,3.012,3.012,0,0,1,2.894,2.281,3.712,3.712,0,0,1-2.41,4.479c-.08.022-.162.042-.24.056a4.166,4.166,0,0,1-.717.067l-1.412.006a.575.575,0,0,0,0,1.15h0l1.415-.006a5.255,5.255,0,0,0,.918-.087c.124-.023.236-.048.343-.079A4.863,4.863,0,0,0,35.938,25.063Z",
    transform: "translate(-13 -13)",
    fill: "#1d1d1b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283713",
    "data-name": "Pfad 283713",
    d: "M25.5,25.013a.576.576,0,0,0-.575.575V35a.575.575,0,1,0,1.15,0V25.588A.576.576,0,0,0,25.5,25.013Z",
    transform: "translate(-13 -13)",
    fill: "#1d1d1b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283714",
    "data-name": "Pfad 283714",
    d: "M28.907,27.094l-3-3a.575.575,0,0,0-.814,0l-3,3a.575.575,0,0,0,.814.812L25.5,25.313l2.593,2.593a.575.575,0,0,0,.814,0A.575.575,0,0,0,28.907,27.094Z",
    transform: "translate(-13 -13)",
    fill: "#1d1d1b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18787",
    "data-name": "Gruppe 18787",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24196",
    "data-name": "Rechteck 24196",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageDesktop);
export default __webpack_public_path__ + "static/media/upload-image-desktop.0f0af0392ce087ef7b76ee4c25d57f38.svg";
export { ForwardRef as ReactComponent };